import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-compiling-icon',
  templateUrl: './code-compiling.component.html'
})
export class CodeCompilingComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
